import { IconButton, Tooltip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggle = () => {
    const next = i18n.language === 'zh_hk' ? 'en_hk' : 'zh_hk';
    i18n.changeLanguage(next);
    localStorage.setItem('wedding_lang', next);
  };

  const label = i18n.language === 'zh_hk' ? 'EN' : '繁';

  return (
    <Tooltip title={i18n.language === 'zh_hk' ? 'Switch to English' : '切換至繁體中文'}>
      <IconButton
        onClick={toggle}
        size="small"
        sx={{
          position: 'fixed',
          top: { xs: 6, sm: 8 },
          right: { xs: 8, sm: 12 },
          zIndex: 1300,
          bgcolor: 'rgba(255,255,255,0.55)',
          border: '1px solid',
          borderColor: 'divider',
          boxShadow: 1,
          width: { xs: 36, sm: 40 },
          height: { xs: 36, sm: 40 },
          fontSize: '0.7rem',
          fontWeight: 700,
          '&:hover': { bgcolor: 'rgba(255,255,255,0.8)' },
        }}
      >
        <LanguageIcon sx={{ fontSize: '0.8rem', mr: 0 }} />
        {label}
      </IconButton>
    </Tooltip>
  );
}
